import React, {useEffect} from 'react';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import {fade, makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import InputBase from '@material-ui/core/InputBase';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import SearchIcon from '@material-ui/icons/Search';
import Product from "../../Containers/Product/Product";
import axios from 'axios'
import CircularProgress from '@material-ui/core/CircularProgress';
import Filter from "../../Containers/Filter/Filter";
import Basket from "../../Containers/Basket/Basket";
import Footer from "../Footer/Footer";
import Box from '@material-ui/core/Box';
import Popover from '@material-ui/core/Popover';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import Button from '@material-ui/core/Button';
import BodyBasket from "../BodyBasket/BodyBasket";
import Pagination from '@material-ui/lab/Pagination';

const Home = (props) =>  {
    const getData = () => {
        const {setProducts} = props;
        axios.get('/products.json').then(res => {
            setProducts(res.data)
        }
       )
    }
    useEffect(() => {
        getData()
    },[]);

    const classes = useStyles();
    const {products,isReady,searchQuery,setSearchQuerye,cartsTotal,removeFromCart} = props;

    return (
        <React.Fragment>
            <div className={classes.root}>
                <AppBar position="static">
                    <Toolbar>
                        <Typography className={classes.title} variant="h6" noWrap>
                            Shop Notebooks
                        </Typography>
                        <div className={classes.search}>
                            <div className={classes.searchIcon}>
                                <SearchIcon/>
                            </div>
                            <InputBase
                                    value={searchQuery}
                                onChange={e => setSearchQuerye(e.target.value)}
                                placeholder="Search…"
                                classes={{
                                    root: classes.inputRoot,
                                    input: classes.inputInput,
                                }}
                                inputProps={{ 'aria-label': 'search' }}
                            />
                        </div>
                            <Basket/>
                        <PopupState variant="popover" popupId="demo-popup-popover">
                            {popupState => (
                                <div>
                                    <Button variant="contained" color="primary" {...bindTrigger(popupState)}>
                                        <ShoppingBasketIcon/>
                                    </Button>
                                    <Popover
                                        {...bindPopover(popupState)}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'center',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'center',
                                        }}>
                                        <Box p={2}>
                                            <Typography>
                                                <BodyBasket key={Date.now()}   cartsTotal={cartsTotal}
                                                 removeFromCart={removeFromCart}/>
                                            </Typography>
                                        </Box>
                                    </Popover>
                                </div>
                            )}
                        </PopupState>


                    </Toolbar>
                </AppBar>
            </div>
            <CssBaseline />
                <Filter />
            <main>
                <Container className={classes.cardGrid} maxWidth="lg">
                    <Grid container spacing={4} >
                        {!isReady ? <CircularProgress className={classes.preloader}/> :  products.map((product,i) => (
                            <Product key={i} {...product}/>
                        ))}
                    </Grid>
                </Container>

                <Footer/>
            </main>

        </React.Fragment>
    );
}
export default Home





const useStyles = makeStyles((theme) => ({

    icon: {
        marginRight: theme.spacing(2),
    },
    heroContent: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(8, 0, 6),
    },
    heroButtons: {
        marginTop: theme.spacing(4),
    },
    cardGrid: {
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(8),
    },
    card: {
        height: '104%',
        width:'104%',
        display: 'flex',
        flexDirection: 'column',
    },
    cardMedia: {
        paddingTop: '56.25%', // 16:9
    },
    cardContent: {
        flexGrow: 1,
    },
    footer: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(6),
    },
    root: {
        flexGrow: 1,
    },
    title: {
        flexGrow: 1,
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
    search: {
        position: 'relative',
        left: '-45px',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(1),
            width: 'auto',
        },
    },
    preloader:{
        margin: '0 auto'
    },

    searchIcon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
    },

    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
    },

}));